// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1921ccbe","732":"bf135a9e","977":"80863d36"}[chunkId] + ".chunk.js";
};